<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="homestay">
        <div class="card-horizontal__user d-flex">
            <div class="card-horizontal__user-left">

                <div v-if="homestay.view_mode === 'homestay'"  class="card-horizontal__user-photo">
                    <img :src="`/storage${homestay.images[0].path.replace('original', 'preview_l')}`" alt="" v-if="homestay.images.length">
                    <span v-text="getUserPM(homestay.name)"></span>
                </div>
                <a :href="`/user/${homestay.user.id}/profile`" class="card-horizontal__user-photo" v-else>
                    <img :src="`/storage${homestay.user.avatar.path.replace('original', 'avatar')}`"  alt="" v-if="homestay.user.avatar">
                    <span v-text="getUserPM(homestay.user.name)"></span>
                </a>

            </div>
            <div class="card-horizontal__user-right">
                <div class="card-horizontal__user-name d-flex">
                    <div v-if="homestay.view_mode === 'homestay'">
                        {{homestay.name}}
                    </div>
                    <a :href="`/user/${homestay.user.id}/profile`" v-else>
                        {{homestay.user.name}}
                    </a>
                    <div class="card-horizontal__user-location"><span class="lnr lnr-map-marker"></span>{{homestay.city.name}}</div>

                </div>

                <div class="card-horizontal__user-descr" :style="{'-webkit-line-clamp': !openDescription ? 3 : 'unset'}" v-if="contentHeight > 66">

                    <template v-if="!openDescription">
                        <span class="card-horizontal__user-descr-content" v-html="homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='#' @click.prevent="openDescription = true" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_read_more')}}</a></span>
                    </template>
                    <template>
                        <span class="card-horizontal__user-descr-content" v-html="homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span> &nbsp;
                        <span><a href='#' @click.prevent="openDescription = false" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_collapse')}}</a></span>
                    </template>


                </div>
                <div class="card-horizontal__user-descr" v-else
                     v-html="(homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, ''))">
                </div>

                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row d-flex">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--homestay"></span>
                        {{$store.getters.t(homestay.type === 'enclosure' ? 'homestays_type_enclosure' : 'homestays_type_apartment')}}
                    </div>
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--duration"></span>
                        {{homestay.min_duration}}{{(homestay.max_duration ? `-${homestay.max_duration}` : '')}}
                    </div>
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--charge"></span>
                        {{homestay.charge_category === 'paid_for' ? $store.getters.t('facilities_store_form_paid') : $store.getters.t('facilities_store_form_free')}}
                    </div>
                </div>

                <div class="card-horizontal__user-photos d-flex" v-if="homestay.images.length">


                    <a class="card-horizontal__user-photos-item" :class="{'card-horizontal__user-photos-item--block': idx < 3}"
                       v-for="(image, idx) in homestay.images" :href="`/storage${image.path}`"
                       :data-lightbox="'homestay-' + homestay.id"
                       :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>

                    <div class="card-horizontal__user-photos-item card-horizontal__user-photos-item--block d-flex" v-if="homestay.images.length > 3">
                        +{{homestay.images.length - 3}}
                    </div>

                </div>
                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row ">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <div class="card-horizontal__user-paragraph-title">
                            <span class="lnr lnr-map-marker"></span>{{$store.getters.t('homestays_address')}}:
                        </div>
                        {{homestay.street_address}}
                    </div>
                </div>

                <div class="card-horizontal__user-contact d-flex">
                    <a href="#" class="card-horizontal__user-contact-link">{{$store.getters.t('organizations_profile_pet_view')}}</a>
                    <a :href="`tel:${homestay.user.public_phone}`" v-if="homestay.user && homestay.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">{{$store.getters.t('donors_card_call')}}</a>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserDashboardFacilitiesHomestays",
    props: ['homestay', 'index'],
    data(){
        return{
            contentHeight: 0,
            media: null,
            openDescription: false,
        }
    },

    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },

    mounted(){
        this.getContent(this.index)
    },

    watch:{
        media() {
            this.getContent(this.index)
        },
    },

    methods:{

        myEventHandler(e){
            this.media = window.innerWidth
        },

        getContent(index){

            if(typeof index !== 'number') return this.contentHeight = 0

            let descr = document.querySelector(`.card-horizontal__${index} .card-horizontal__user-descr`).scrollHeight

            this.contentHeight = descr
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }

}
</script>

<style scoped>

</style>
